export enum IndicatorLineStatus {
  YELLOW = 'yellow',
  BLUE = 'blue',
  None = 'none',
}

export type IndicatorLineProps = {
  status: IndicatorLineStatus;
};
